import clsx from "clsx";
import { RichTextContent } from "contentful";
import { Grid } from "@mui/material";
import CmsTextEditorContent from "@Libs/contentful/components/cms-text-editor/CmsTextEditor";
import classes from "./SectionBasic.module.scss";

interface SectionBasicProps {
  heading?: string | RichTextContent | any;
  paragraph?: string | RichTextContent | any;
  isList?: boolean;
  button?: React.ReactNode;
  backgroundImage?: string;
  backgroundImageClassName?: string;
  className?: string;
  paragraphClassName?: string;
  sectionButtonClassName?: string;
  children?: React.ReactNode;
}

export const SectionBasic = (props: SectionBasicProps) => {
  const {
    heading,
    paragraph,
    isList = false,
    button,
    children,
    backgroundImage,
    backgroundImageClassName,
    className = "",
    paragraphClassName = "",
    sectionButtonClassName,
  } = props;

  const displayParagraph = () => {
    return paragraph ? (
      typeof paragraph === "string" ? (
        <p
          className={`section__paragraph ${classes["section__paragraph--basic"]}`}
        >
          {paragraph}
        </p>
      ) : isList === true ? (
        <div className={paragraphClassName}>
          <ul className={classes[`section__list`]}>
            {paragraph.map((quote: string, index: number) => {
              return (
                <li key={index} className={classes[`section__list__item`]}>
                  <div className={classes[`section__list__item__index`]}>
                    <p className={classes[`section__list__item__index`]}>
                      {index + 1}.
                    </p>
                  </div>
                  <p className={classes[`section__list__item__quote`]}>
                    {quote}
                  </p>
                </li>
              );
            })}
          </ul>
        </div>
      ) : (
        <div className={paragraphClassName}>
          <CmsTextEditorContent content={paragraph} />
        </div>
      )
    ) : null;
  };

  return (
    <section className={className}>
      <div className={`section ${classes["section--basic"]}`}>
        {!!backgroundImage && (
          <div
            className={clsx(
              classes["section--basic__background"],
              backgroundImageClassName
            )}
            style={{ backgroundImage: `url(${backgroundImage})` }}
          />
        )}
        <Grid
          container
          className="section__content"
          direction="row"
          alignItems="center"
        >
          <Grid item xs={12} md={6}>
            {heading &&
              (typeof heading === "string" ? (
                <h2
                  className={`section__heading ${classes["section__heading--basic"]}`}
                >
                  {heading}
                </h2>
              ) : (
                <div
                  className={`section__heading ${classes["section__heading--basic"]}`}
                >
                  <CmsTextEditorContent content={heading} />
                </div>
              ))}
            {displayParagraph()}
            {button && (
              <div
                className={clsx(
                  classes["section__button"],
                  sectionButtonClassName
                )}
              >
                {button}
              </div>
            )}
          </Grid>
          <Grid item xs={12} md={6}>
            {children}
          </Grid>
        </Grid>
      </div>
    </section>
  );
};
